import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledInputLabel = styled(UIInlineLabel).withConfig({
  displayName: "MetadataInputLabel__StyledInputLabel",
  componentId: "o8mrms-0"
})(["width:90%;flex-grow:1;margin-top:-1px;font-size:14px;font-weight:500;"]);
const MetadataInputLabel = props => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(StyledInputLabel, Object.assign({}, rest, {
    children: children
  }));
};
MetadataInputLabel.displayName = 'MetadataInputLabel';
export default MetadataInputLabel;